<template>
  <div
    v-if="!printerFriendly"
    class="container-fluid pt1">
    <div class="row rd-gridsystem-scrollbar-wrap compareByFilter">
      <div class="rdResponsiveColumn col-lg-1 col-md-1 col-sm-1 col-xs-2 compareByFilterCol">
        <label
          for="searchinput"
          class="compareByFilterSearch">Search Report</label>
        <div class="compareByFilterElements">
          <input
            id="searchinput"
            v-model="searchInput"
            class="search"
            type="text"
            width="200px"
            @keyup.enter="searchClicked">
        </div>
      </div>
      <div class="rdResponsiveColumn col-lg-1 col-md-1 col-sm-1 col-xs-2 compareByFilterCol">
        <span class="compareByFilterElements">
          <button @click="searchClicked">Search</button>
        </span>
        <span class="compareByFilterElements">
          <a
            href="#"
            @click.prevent="resetSearch">Clear</a>
        </span>
      </div>
      <div class="rdResponsiveColumn col-lg-1 col-md-1 col-sm-1 col-xs-2 compareByFilterCol">
        <span
          v-if="searchString"
          class="compareByFilterElements tc"
        ><span class="searchHits">{{ searchHits }} Results</span></span>

      </div>
      <div class="rdResponsiveColumn col-lg-1 col-md-1 col-sm-2 col-xs-1 compareByFilterCol">
        <span class="compareByFilterShow">
          <a
            href="#"
            class="showHideLink"
            @click.prevent="setShowReportOptions(!showReportOptions)"
          >{{ showReportOptions ? 'Hide Options' : 'Show Options ' }}</a>
        </span>
      </div>
      <div class="rdResponsiveColumn col-lg-2 col-md-2 col-sm-3 col-xs-1 compareByFilterCol pl-0">
        <span class="compareByFilterElements">
          <input
            ref="addRemoveButton"
            :value = "'Add/Remove ' + compareByLabelPlural"
            type="button"
            @click.prevent="showModal()">
        </span>
      </div>
      <div
        class="rdResponsiveColumn col-lg-3 col-md-3 col-sm-3 col-xs-6 row compareByFilterColExp"
        style="height: 56px">
        <div class="container-fluid compareByFilterElements">
          <!-- <div class="row">
            <div class="rdResponsiveColumn col-lg-6 col-md-2 col-sm-6 col-xs-6 NestedExp">
              <span class="exportLogo">
                <img
                  src="./assets/pdf-small.png"
                  alt="CDC logo">
              </span>
            </div>
            <div class="rdResponsiveColumn col-lg-6 col-md-2 col-sm-6 col-xs-6 NestedExp">
              <span class="exportText">
                <a
                  href="#"
                  @click.prevent="saveAsPdf">Save as PDF</a>
                <a
                  v-if="showPrinterFriendlyTestLink"
                  :href="printerFriendlyViewUrl"
                  target="_blank">PF test</a>
              </span>
            </div>
          </div> -->
          <div class="row">
            <div class="rdResponsiveColumn col-lg-6 col-md-2 col-sm-6 col-xs-6 NestedExp pr-0">
              <span class="exportLogo">
                <img
                  src="./assets/csv-small.png"
                  alt="CDC logo">
              </span>
            </div>
            <div class="rdResponsiveColumn col-lg-6 col-md-2 col-sm-6 col-xs-6 NestedExp pl-0">
              <span class="exportText">
                <a
                  href="#"
                  @click.prevent="exportCsv">Save as CSV</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CRColumnSelectModal
      @modalClosed="setFocusToAddRemoveButton"/>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import FileSaver from 'file-saver';
import CRColumnSelectModal from './CRColumnSelectModal';


export default {
  components: {
    CRColumnSelectModal,
  },
  data() {
    return {
      searchInput: '',
    };
  },
  computed: {
    ...mapState({
      searchString: state => state.CR.searchString,
      showReportOptions: state => state.CR.flags.showReportOptions,
      reportType: state => state.CR.GSGo.reportType,
      GSGo: state => state.CR.GSGo,
      compareColumns: state => state.CR.compareColumns,
    }),
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    categoriesFiltered() {
      return this.$store.getters['CR/categoriesFiltered'];
    },
    searchHits() {
      return this.$store.getters['CR/searchHits'];
    },
    compareByLabelPlural() {
      if (this.reportType === 'Locations') return 'Locations';
      if (this.reportType === 'Demographics') {
        if (this.GSGo.stratCatId === 'AGEGRP') return 'Age Groups';
        if (this.GSGo.stratCatId === 'SEX') return 'Sexes';
        if (this.GSGo.stratCatId === 'RACE') return 'Races/Ethnicities';
      }
      if (this.reportType === 'Years') return 'Years';
      throw new Error(`Unknown reportType: ${this.reportType}`);
    },
    printerFriendlyQueryString() {
      // remove SearchString parm to prevent PDF from showing search highlights
      // remove ShowCategoryIds then add it back to include all filtered categories (conditionally)
      return `${_.map(_.assign(
        _.omit(this.$route.query, 'SearchString', 'ShowCategoryIds'),
        {
          ShowCategoryIds: process.env.ExpandAllCategoriesInCrPdf ?
            _(this.categoriesFiltered).map('id').value().join() :
            this.$route.query.ShowCategoryIds,
        },
      ), (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')}&showMode=export`;
    },
    printerFriendlyViewUrl() {
      return `${window.location.origin}${process.env.RouterBase}${this.$route.path}?${this.printerFriendlyQueryString}`;
    },
    showPrinterFriendlyTestLink() {
      return process.env.ShowPrinterFriendlyTestLink;
    },
  },
  watch: {
    searchString: {
      handler() {
        this.searchInput = this.searchString;
      },
      immediate: true,
    },
  },
  methods: {
    showCategoriesWithSearchHits() {
      const newShowCategoryIds = _(this.categoriesFiltered).reduce((acc, obj) => {
        acc[obj.id] = this.$store.getters['CR/searchHitsForCategory'](obj.id) > 0;
        return acc;
      }, {});
      this.$store.commit('CR/setShowCategoryIds', newShowCategoryIds);
    },
    resetSearch() {
      this.searchInput = '';
      this.$store.commit('CR/setSearchString', '');
    },
    searchClicked() {
      this.$store.commit('CR/setSearchString', this.searchInput);
      this.showCategoriesWithSearchHits();
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    },
    showModal() {
      this.$modal.show('columns-modal');
    },
    setShowReportOptions(bool) {
      this.$store.commit('CR/setShowReportOptions', bool);
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    },
    setFocusToAddRemoveButton() {
      this.$refs.addRemoveButton.focus();
    },
    saveAsPdf() {
      this.$store.dispatch('CR/triggerInteraction', { type: 'CRE', exportType: 'PDF' });
      const url = `${window.location.protocol}//${window.location.host}/${this.$route.path}?${this.printerFriendlyQueryString}`;
      // eslint-disable-next-line
      console.log(url);
      window.open(url, '_blank');
      this.$store.commit('CR/setGeneratingPdf', true);
      /*
      api.post('ExportToPDF', {
        exportFormat: this.compareColumns.length > 3 ? 2 : 1, // 1: PDF, 2: PDFLandscape
        myVirtualDirectoryOnDev: process.env.MyVirtualDirectoryOnDev,
        urlToRender: url,
        exportFileName: 'Export.pdf',
        conversionDelaySec: 10,
      }, {
        responseType: 'blob',
      }).then((response) => {
        FileSaver.saveAs(response.data, 'Export.pdf');
        this.$store.commit('CR/setGeneratingPdf', false);
      }).catch((err) => {
        this.$notify({
          type: 'error',
          title: 'Export error',
          text: `Export to PDF failed: ${err.response.status} ${err.response.statusText}`,
        });
        this.$store.commit('CR/setGeneratingPdf', false);
      });
      */
    },
    exportCsv() {
      this.$store.dispatch('CR/triggerInteraction', { type: 'CRE', exportType: 'CSV' });
      const csv = this.$store.getters['CR/csvExport'];
      // console.log(csv);
      const blob = new Blob([csv], { type: 'text/html;charset=utf-8' });
      FileSaver.saveAs(blob, 'Export.csv');
    },
  },
};
</script>

<style scoped>
  input[type=text].search {
    font-size: 14px;
  }
  .searchHits {
    background-color: yellow;
  }
  .tc {
    text-align: center;
  }
  .compareByFilterShow {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    white-space: nowrap;
  }

  a.compareByFilterShow {
    text-decoration: underline;
  }


</style>



// WEBPACK FOOTER //
// src/components/CR/CRSearchBar.vue